import { IncPlaybookSectionBox, PAGE_PREFIX } from '../IncrementalityPlaybookShared';
import { playbookTable } from '../PlaybookTable';

export const About = () => (
  <div className='inc-playbook-page'>
    <IncPlaybookSectionBox
      content={
        <div className='basic-section'>
          <div className='basic-text'>
            This is a codification of our portfolio of methods for evaluating the incremental impact
            of media investments and tactics. This will serve as a playbook, spanning all channels,
            of experimental and quasi-experimental options for testing and measuring incrementality.
            This master playbook will standardize and govern the most appropriate methods by channel
            and/or platform.
          </div>
          <br />
          <br />
          <div className='basic-header'>The Playbook Impact:</div>
          <ul className='basic-list'>
            <br />
            <li>
              As deterministic signals erode, experimental design allows us to more confidently
              measure and quantify the lift attributable to media.
            </li>
            <li>
              To encourage clients to use incrementality studies to calibrate channel performance
              and media investment allocation, and to deliver this solution with high quality and
              consistency, at low cost.
            </li>
            <li>
              To reduce cost of execution and to drive consistency and repeatability in approach.
            </li>
          </ul>
          <br />
          <br />
          <div className='basic-text'>
            For more information on this type of measurement refer to{' '}
            <a href={`${PAGE_PREFIX}/Incrementality101`}> Incrementality 101.</a> For any general
            feedback or feature requests, we encourage you to share your thoughts on our dedicated{' '}
            <a href='https://tinuiti.slack.com/archives/C05HHT6JETE'>Slack channel.</a>
          </div>
        </div>
      }
      title='About the Incrementality Playbook'
    />
    <IncPlaybookSectionBox
      content={<div className='main-table'>{playbookTable()}</div>}
      title='Incrementality Testing Approaches'
    />
  </div>
);
